<section class="relative w-full">

  <figure class="w-full h-full relative flex items-center justify-start pt-24 pb-24 px-4 md:px-36">

    <img
      src="https://cic-dev.eshtri-cluster-eu-de-1-bx-8f23923b84c5cec3cecb2d74397b77c3-0000.eu-de.containers.appdomain.cloud/uploads/gcc_BG_3a282a9af9.png"
      class="object-cover absolute inset-0 w-full h-full -z-10" alt="Global Capability Center" />

    <div class="absolute inset-0 -z-10"></div>

    <figcaption>

      <div class="text-white max-w-3xl py-24 flex flex-col items-start gap-6">

        <p class="uppercase tracking-widest text-sm opacity-80">
          Enterprise Transformation
        </p>

        <h1 class="font-light text-5xl leading-normal">
          Global Capability Center
        </h1>

        <p class="text-xl leading-relaxed">
          CIC operates as a unified Global Capability Center delivering
          Build, Run, and Modernize services across SAP and enterprise
          digital platforms.
        </p>

        <button
          class="py-2 bg-white w-fit hover:bg-white/90 hover:underline text-primary-600 rounded-full px-6 flex items-center gap-2"
          (click)="scrollToSection('contact-us')">
          Contact us</button>
      </div>
    </figcaption>
  </figure>

</section>